const id = {
  meta: { code: "id", label: "Bahasa Indonesia" },
  nav: {
    brand: "IQ Log",
    diagnostics: "Diagnostik",
    mypage: "Halaman Saya",
    login: "Masuk",
    register: "Daftar",
    logout: "Keluar",
  },
  hero: {
    eyebrow: "Platform diagnostik",
    title: "Temukan esensi dirimu lewat diagnostik",
    subtitle1: "Pemikiran, kepribadian, dan bakat — sepenuhnya tervisualisasi",
    subtitle2: "Lihat kekuatan & kelemahanmu dalam 5 menit",
    subtitle3: "Setiap diagnostik menjadi datamu",
    cta_primary: "Mulai diagnostik",
    cta_secondary: "Lihat katalog",
    disclaimer: "Info referensi / Non-medis",
  },
  categories: {
    ability: "Kemampuan",
    personality: "Kepribadian",
    mental: "Mental",
    aptitude: "Bakat",
    traits: "Sifat",
  },
  catalog: {
    title: "Semua Diagnostik",
    subtitle: "17 tes / 5 kategori",
    filter_all: "Semua",
    duration: "mnt",
    difficulty: { easy: "Mudah", medium: "Menengah", hard: "Sulit" },
    question_count: "soal",
    start: "Mulai",
  },
  quiz: {
    question: "Pertanyaan",
    of: "/",
    next: "Berikutnya",
    prev: "Kembali",
    submit: "Lihat hasil",
    progress: "Progres",
    exit: "Keluar",
    required: "Silakan pilih opsi",
    submitting: "Menilai…",
  },
  result: {
    overall: "Skor keseluruhan",
    type_label: "Tipe",
    share_link: "Bagikan hasil dengan tautan",
    back_to_catalog: "Ambil diagnostik lain",
    view_mypage: "Lihat riwayat di Halaman Saya",
    premium_title: "Buka analisis terperinci",
    premium_subtitle: "Dengan premium, kamu akan melihat semua di bawah:",
    feature_breakdown: "Rincian skor terperinci",
    feature_cause: "Analisis akar penyebab",
    feature_plan: "Rencana perbaikan",
    feature_pdf: "Laporan PDF (A4)",
    price: "¥980",
    price_note: "(Pembayaran aman via Stripe)",
    price_free: "Gratis",
    price_free_note: "(Waktu terbatas · 100% gratis)",
    unlock_button: "Bayar dengan Stripe",
    unlock_button_free: "Buka gratis",
    unlock_requires_auth: "Silakan masuk untuk membuka",
    unlock_save_first: "Simpan hasilmu dengan akun terlebih dahulu",
    unlocking: "Mengarahkan ke Stripe…",
    free_only_notice: "Tier gratis hanya menampilkan skor keseluruhan dan tipe.",
    compliance_note:
      "Diagnostik ini hanya memberikan informasi referensi dan bukan diagnosis medis. Kami menghindari bahasa pasti atau menakut-nakuti.",
  },
  premium: {
    title: "Laporan analisis terperinci",
    summary: "Ringkasan keseluruhan",
    strengths: "Kekuatan",
    weaknesses: "Area pengembangan",
    improvements: "Rencana perbaikan",
    dimensions: "Skor dimensi",
    download_pdf: "Unduh PDF",
    pdf_soon: "Ekspor PDF (segera hadir)",
  },
  mypage: {
    title: "Halaman Saya",
    subtitle: "Riwayat, tren skor, dan lencana kamu",
    total: "Total diagnostik",
    average: "Skor rata-rata",
    premium_count: "Terbuka",
    categories_covered: "Kategori tercakup",
    trend_title: "Tren skor",
    history_title: "Riwayat",
    badges_title: "Lencana",
    unlock_3_title: "Buka Analisis Komposit",
    unlock_3_desc: "Ambil {n} diagnostik lagi untuk membuka analisis komposit",
    unlocked: "Analisis komposit terbuka",
    no_history: "Belum ada diagnostik — ambil yang pertama sekarang.",
  },
  auth: {
    login_title: "Masuk",
    register_title: "Buat akun",
    email: "Email",
    password: "Kata sandi (min 6 karakter)",
    name: "Nama tampilan (opsional)",
    login_btn: "Masuk",
    register_btn: "Daftar",
    go_register: "Belum punya akun? Daftar",
    go_login: "Sudah punya akun? Masuk",
    anon_note: "Diagnostik gratis dan anonim. Akun hanya diperlukan untuk menyimpan hasil dan membuka premium.",
    success_register: "Akun dibuat",
    success_login: "Berhasil masuk",
    consent_section: "Persetujuan",
    consent_required: "Mohon terima item yang wajib",
    accept_terms_pre: "Saya setuju dengan",
    terms_link: "Ketentuan Layanan",
    accept_terms_post: "",
    accept_privacy_pre: "Saya telah membaca",
    privacy_link: "Kebijakan Privasi",
    accept_privacy_post: "dan menyetujui pemrosesan data pribadi saya",
    accept_age: "Saya berusia 16 tahun atau lebih (atau memiliki persetujuan wali sah)",
    accept_marketing: "Kirim saya email tentang diagnostik baru dan promosi",
    optional: "opsional",
  },
  landing: {
    status_online: "SYSTEM ONLINE",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 TES",
    status_langs: "14 BAHASA",
    status_ai: "AI · ON",
    title_line1: "Temukan esensi dirimu",
    title_line2: "dalam 5 menit.",
    trust_diagnostics: "DIAGNOSTIK",
    trust_languages: "BAHASA",
    trust_per_test: "PER TES",
    hud_readout: "BACAAN UTAMA",
    hud_score_unit: "/100 TOTAL",
    hud_band: "TINGKAT · GOLD",
    hud_dimensions: "DIMENSI",
    hud_dimensions_status: "3 / 3 AKTIF",
    hud_syslog: "LOG SISTEM",
    cat_eyebrow: "// KATEGORI",
    cat_title_pre: "5 kategori · ",
    cat_title_highlight: "17 diagnostik",
    view_all: "Lihat semua",
    proto_eyebrow: "// PROTOKOL",
    proto_title_pre: "Buka esensimu ",
    proto_title_highlight: "dalam 3 langkah.",
    step1_title: "Pilih tes",
    step1_body: "Pilih dari 17 tes. Mulai anonim.",
    step2_title: "Jawab dalam 5 menit",
    step2_body: "Bar progres + lencana terus mendukung.",
    step3_title: "Buka oleh AI",
    step3_body: "Skor terperinci, rencana & PDF.",
    final_eyebrow: "// SIAP?",
    final_title_pre: "Esensimu ",
    final_title_highlight: "dalam 5 menit.",
    final_subtitle: "Lihat kekuatan & kelemahanmu dalam 5 menit",
    final_button: "Mulai diagnostik sekarang",
  },
  footer: {
    tagline: "Platform diagnostik untuk pemikiran, kepribadian, dan bakatmu",
    rights: "Semua hak dilindungi.",
    legal: "Hukum",
    privacy: "Privasi",
    terms: "Ketentuan",
    about_label: "Tentang / Perusahaan",
    compliance_label: "Kepatuhan Internasional",
    tokushoho_label: "Tokushoho (Jepang)",
    data_protection_label: "Perlindungan Data (Internasional)",
    data_request_label: "Hapus Data / Opt-out",
    disclaimer_label: "Penafian",
    disclaimer_full:
      "Layanan ini hanya untuk referensi dan bukan diagnosis medis. Kami tidak menggunakan bahasa pasti atau menakut-nakuti.",
  },
  badges: {
    "first-diagnosis": "Diagnostik Pertama",
    "three-diagnostics": "3 Diagnostik",
    "five-diagnostics": "5 Diagnostik",
    "ten-diagnostics": "10 Diagnostik",
    "high-performer": "Berkinerja Tinggi",
    "premium-user": "Pengguna Premium",
  },
  lang_selector: "Bahasa",
  payment: {
    processing_title: "Memverifikasi pembayaran…",
    processing_subtitle: "Kembali dari Stripe — menghasilkan analisis terperinci (hingga 20 detik)",
    success: "Pembayaran dikonfirmasi — premium terbuka",
    expired: "Sesi checkout kedaluwarsa. Silakan coba lagi.",
    error: "Tidak dapat memverifikasi pembayaran. Hubungi dukungan.",
  },
};
export default id;
